export default (type, payload) => ({
  type,
  payload,
})



// WEBPACK FOOTER //
// ./src/helpers/buildAction.js